module.exports = __webpack_public_path__ + "static/img/1diamond-tag@3x.1e0bb421.png";